import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import WelcomePage from '@/components/WelcomePage.vue'
import AppLaunch from '../views/AppLaunch.vue';
import Index from "../views/Index.vue";

// Account
import Login from "../views/account/Login.vue";
import SignUp from "../views/account/SignUp.vue";
import SignUpOTPVerification from "../views/account/SignUpOTPVerification.vue";
import ForgotPassword from '../views/account/ForgotPassword.vue';
import PasswordOTPVerification from "../views/account/PasswordOTPVerification.vue";
import ResetPassword from "../views/account/ResetPassword.vue";
import ProfileView from '../views/account/ProfileView.vue'

// Admin
import Reservations from "../views/admin/Reservations.vue";
import ReservationDetail from "../views/admin/ReservationDetail.vue";
import AChargingStatusDetail from '../views/admin/ChargingStatusDetail.vue'
import ChargingStations from "../views/admin/ChargingStations.vue";
import ChargingStationDetail from "../views/admin/ChargingStationDetail.vue";
import Chargers from "../views/admin/Chargers.vue";
import ChargerDetail from "../views/admin/ChargerDetail.vue";
import ChargerInstallations from "../views/admin/ChargerInstallations.vue";
import ChargerInstallationDetail from "../views/admin/ChargerInstallationDetail.vue";
import ManageUsers from '../views/admin/MangeUsers.vue';
import AdminDashboard from "../views/admin/AdminDashboard.vue";
import ChargerStatusList from "../views/admin/ChargerStatusList.vue";
import CPOCreation from '../views/admin/CPOCreation.vue';
// import createCorporateName from '../views/admin/createCorporateName.vue';
import CorporateNameList from '../views/admin/CorporateNameList.vue';
import addNewCorporate from '../views/admin/addNewCorporate.vue';
import tariffCreation from '../views/admin/TariffCreation.vue';
import CPOUserCreation from '../views/admin/CPOUserCreation.vue';
import AddNewUser from '../views/admin/AddNewUser.vue';
import AddNewTariff from '../views/admin/AddNewTariff.vue';
import TariffDetails from '../views/admin/TariffDetails.vue';
import UserDetails from '../views/admin/UserDetails.vue';
import ViewAllReports from '../views/admin/ViewAllReports.vue';
import EditReservationUsage from '@/views/admin/EditReservationUsage.vue';

// Customer
import NewReservation from '../views/customer/NewReservation.vue';
import MyEVehicles from '../views/customer/MyEVehicles.vue'
import selectVehicle from '../views/customer/resSelectVehicle.vue'
import MyEVehicleDetail from '../views/customer/MyEVehicleDetail.vue'
import ReservationFilter from '../views/customer/reservationFilter.vue'
import MyReservations from '../views/customer/MyReservations.vue'
import bookNow from '../views/customer/bookNow.vue'
import slotBooking from '../views/customer/slotBooking.vue'
import confirmPage from '../views/customer/confirmPage.vue'
import resConfirm from '../views/customer/resConfirm.vue'
import MyReservationDetail from '../views/customer/MyReservationDetail.vue'
import ChargingOTPVerification from '../views/customer/ChargingOTPVerification.vue'
import ChargingStatusDetail from '../views/customer/ChargingStatusDetail.vue'
import Userwallet from '../views/customer/UserWallet.vue'
import UserProfile from '../views/account/Profile.vue'
import ChangePassword from '../views/account/ChangePassword.vue'
import DiscountOffer from '../views/customer/DiscountOffer.vue';
import MyChargerHome from '../views/customer/MyChargerHome.vue';
import slotBookingForreservation from '@/views/customer/slotBookingForreservation.vue';
import Onboarding from '@/components/customer/Onboarding.vue';

// Corporate
import Corporate from '../views/corporate/corporateManage.vue';
import CorporateDetails from '../views/corporate/corporateDetails.vue';
import Corporates from "../views/corporate/corporates.vue";
import CorporateView from "../components/corporate/corporateView.vue";
import BranchesAndStations from '../views/corporate/branchesAndStations.vue'
import CPOChargingStations from '../views/corporate/CPOCharginStations.vue';
import CPOReservations from '../views/corporate/CPOReservations.vue';
import GlobalOTPVerification from '../views/corporate/globalOTPVerification.vue';
import Dashboard from '../views/corporate/Dashboard.vue';
import BranchCPO from '../views/corporate/branchCPO.vue';
import BranchDetails from '../views/corporate/branchDetails.vue';
import BranchView from '../components/corporate/branchView.vue';
import ManageUserToBranch from '../views/corporate/manageUserToBranch.vue';
import AssociateUserToBranch from '../views/corporate/associateUserToBranch.vue';
import UserBranchRelationshipDetails from '../components/corporate/userBranchRelationshipDetails.vue';
import CPOAdminDashboard from '@/views/corporate/CPOAdminDashboard.vue';
import CPOReport from '@/views/corporate/CPOReport.vue';
import UsageReport from '@/views/corporate/usageReport.vue';

// Notifications
import Notifications from "../views/notifications/Notifications.vue";
import NotificationDetails from "../views/notifications/NotificationDetails.vue"

// Common
import About from "../views/common/About.vue";
import Support from "../views/common/Support.vue";
import Helpdesk from "../views/common/Helpdesk.vue";
import GotoWebLogin from "../views/common/GotoWebLogin.vue";
import HelpVideo from "../views/common/HelpVideo.vue";
import Log from "../views/common/Log.vue";
import AddingOTPModel from '@/views/customer/AddingOTPModel.vue';
import AddOTPModel from '@/views/customer/AddOTPModel.vue';

//Carter
import CarterAppLaunch from '@/views/CarterAppLaunch.vue';
import CarterReservation from '@/views/carter/CarterReservation.vue';
import CarterBookNow from '@/views/carter/CarterBookNow.vue';
import CarterProfile from '@/components/carter/CarterProfile.vue';
import CarterStations from '@/components/carter/CarterStations.vue';
import CarterStationDetails from '@/components/carter/CarterStationDetails.vue';
import CarterDashboard from '@/views/carter/carterDashboard.vue';
import CarterUserManagement from '@/components/carter/CarterUserManagement.vue';
import CarterProfileEdit from '@/components/carter/CarterProfileEdit.vue';
import { Component } from 'ionicons/dist/types/stencil-public-runtime';
import TransactionReport from '@/views/corporate/transactionReport.vue';
import chargerStatusReport from '@/views/corporate/chargerStatusReport.vue';
import ManageUserEdit from '@/views/admin/ManageUserEdit.vue';
import ChargerSetup from '@/views/admin/ChargerSetup.vue';



  const routes = [
    {
      path: '',
      name: 'appLaunch',
      component: AppLaunch
    },
    {
      path: '/carter',
      name: 'CarterAppLaunch',
      component: CarterAppLaunch
    },
    {
      path: '/globalOTPVerification',
      name:'globalOTPVerification',
      component: GlobalOTPVerification,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
    },
    {
      path: '/signupverification',
      name: 'signupOtp',
      component: SignUpOTPVerification,
    },
    {
      path: '/signupsuccess',
      name: 'signupSuccess',
      redirect: '/'
    },
    {
      path: '/forgotpassword',
      name: 'forgotPassword',
      component: ForgotPassword
    },
    {
      path: '/passwordverification',
      name: 'passwordOtp',
      component: PasswordOTPVerification
    },
    {
      path: '/resetpassword',
      name: 'resetPassword',
      component: ResetPassword
    },
    {
      path: '/admin',
      component: Index,
      children: [
        {
          path: 'customerprofile/:profileId',
          name: 'customerProfileView',
          component: ProfileView
        }
      ]
    },
    {
      path: '/admin',
      component: Index,
      children: [
        {
          path: 'reservations',
          name: 'reservations',
          component: Reservations
        },
        {
          path: 'reservations/reservation/:reservationId',
          name: 'reservationView',
          component: ReservationDetail
        },
        {
          path: 'reservations/reservation/:bookingId/status',
          name: 'achargingStatusView',
          component: AChargingStatusDetail
        },
        {
          path: 'chargingstations',
          name: 'chargingStations',
          component: ChargingStations
        },
        {
          path: 'chargingstations/station',
          name: 'chargingStationDetail',
          component: ChargingStationDetail
        },
        {
          path: 'chargingstations/station/:stationId',
          name: 'chargingStationView',
          component: ChargingStationDetail
        },
        {
          path: 'chargers',
          name: 'chargers',
          component: Chargers
        },
        {
          path: 'chargers/charger',
          name: 'chargerDetail',
          component: ChargerDetail
        },
        {
          path: 'chargers/charger/:chargerId',
          name: 'chargerView',
          component: ChargerDetail
        },
        {
          path: 'chargerinstallations',
          name: 'chargerInstallations',
          component: ChargerInstallations
        },
        {
          path: 'chargerinstallations/bay',
          name: 'chargerInstallationDetail',
          component: ChargerInstallationDetail
        },
        {
          path: 'chargerinstallations/bay/:bayId',
          name: 'chargerInstallationView',
          component: ChargerInstallationDetail
        },
        {
          path: 'customerprofile/:profileId',
          name: 'customerProfileView',
          component: ProfileView
        },
        {
          path: 'manageUsers',
          name: 'manageUsers',
          component: ManageUsers
        },
        {
          path: 'adminDashboard',
          name: 'adminDashboard',
          component: AdminDashboard
        },
        {
          path: 'chargerStatusList',
          name: 'chargerStatusList',
          component: ChargerStatusList
        },
        {
          path: 'manageUserEdit',
          name: 'manageUserEdit',
          component: ManageUserEdit
        },
        {
          path: 'cpoCreation',
          name: 'cpoCreation',
          component: CPOCreation
        },
        {
          path: 'corporateNameList',
          name: 'corporateNameList',
          component: CorporateNameList
        },
        {
          path: 'addNewCorporate',
          name: 'addNewCorporate',
          component: addNewCorporate
        },
        {
          path: 'tariffCreation',
          name: 'tariffCreation',
          component: tariffCreation
        },
        {
          path: 'CPOUserCreation',
          name: 'CPOUserCreation',
          component: CPOUserCreation
        },
        {
          path: 'addNewUser',
          name: 'addNewUser',
          component: AddNewUser
        },
        {
          path: 'addNewTariff',
          name: 'addNewTariff',
          component: AddNewTariff
        },
        {
          path: 'tariffDetails',
          name: 'tariffDetails',
          component: TariffDetails
        },
        {
          path: 'userDetails',
          name: 'uerDetails',
          component: UserDetails
        },
        {
          path: 'viewAllReports',
          name: 'viewAllReports',
          component: ViewAllReports
        },
        {
          path: 'editReservationUsage/:reservationId',
          name: 'editReservationUsage',
          component: EditReservationUsage
        },
        {
          path: 'chargerSetup',
          name: 'chargerSetup',
          component: ChargerSetup
        }
      ]
    },
    {
      path: "/customer",
      component: Index,
      children: [
        {
          path: 'reservationFilter',
          name: 'reservationFilter',
          component: ReservationFilter
        },
        {
          path: 'reservation',
          name: 'newreservation',
          component: NewReservation
        },
        {
          path: 'reservations',
          name: 'myReservations',
          component: MyReservations
        },
        {
          path: 'bookNow',
          name: 'bookNow',
          component: bookNow
        },
        {
          path: 'slotBooking',
          name: 'slotBooking',
          component: slotBooking
        },
        {
          path: 'slotBookingForreservation',
          name: 'slotBookingForreservation',
          component: slotBookingForreservation
        },
        {
          path: 'selectVehicle',
          name: 'selectVehicle',
          component: selectVehicle
        },
        {
          path: 'confirmPage',
          name: 'confirmPage',
          component: confirmPage
        },
        {
          path: 'resConfirm',
          name: 'resConfirm',
          component: resConfirm
        },
        {
          path: 'reservations/:bookingId',
          name: 'myReservationView',
          component: MyReservationDetail
        },
        {
          path: 'reservations/:bookingId/verification',
          name: 'verifyStartCharging',
          component: ChargingOTPVerification
        },
        {
          path: 'reservations/:bookingId/status',
          name: 'chargingStatusView',
          component: ChargingStatusDetail
        },
        {
          path: 'evehicles',
          // name: 'eVehicles',
          component: MyEVehicles
        },
        {
          path: 'evehicles/vehicle/:vehicleId',
          name: 'eVehicleView',
          component: MyEVehicleDetail
        }
        ,{
          path: 'evehicles/vehicle/:vehicleId',
          name: 'eVehicleEdit',
          component: MyEVehicleDetail
        },
        {
          path: 'evehicles/vehicle/:vehicleType',
          name: 'eVehicleNew',
          component: MyEVehicleDetail
        },
        {
          path: 'ewallet',
          name: 'ewallet',
          component: Userwallet
        },
        {
          path: 'profile',
          name: 'userProfile',
          component: UserProfile
        },
        {
          path: 'profile/changepassword',
          name: 'changePassword',
          component: ChangePassword
        },
        {
          path: 'discountOffer',
          name: 'discountOffer',
          component: DiscountOffer
        },
        {
          path: 'myChargerHome',
          name: 'myChargerHome',
          component: MyChargerHome
        },
        {
          path: 'addOTPModel',
          name: 'AddOTPModel',
          component: AddOTPModel
        },
        {
          path: 'onBoarding',
          name: 'onBoarding',
          component: Onboarding
        }
      ]
    },
    {
      path: '/common',
      component: Index,
      children: [
        {
          path: 'helpdesk',
          name: 'helpdesk',
          component: Helpdesk
        },
        {
          path: 'about',
          name: 'about',
          component: About
        },
        {
          path: 'support',
          name: 'support',
          component: Support
        },
        {
          path: 'log',
          name: 'log',
          component: Log
        },
        {
          path: 'gotoweblogin',
          name: 'gotoweblogin',
          component: GotoWebLogin
        },
        {
          path: 'helpVideo',
          name: 'helpVideo',
          component: HelpVideo
        }
      ]
    },
    {
      path: '/corporate',
      component: Index,
      children: [
        {
          path: 'corporateManage',
          name: 'corporateManage',
          component: Corporate 
        },
        {
          path: 'corporates',
          name: 'corporates',
          component: Corporates 
        },
        {
          path: 'corporateDetails',
          name: 'corporateDetails',
          component: CorporateDetails 
        },
        {
          path: 'corporateView',
          name: 'corporateView',
          component: CorporateView
        },
        {
          path: 'branchesAndStations',
          name: 'branchesAndStations',
          component: BranchesAndStations
        },
        {
          path: 'cpoChargingStations',
          name: 'cpoChargingStations',
          component: CPOChargingStations
        },
        {
          path:'cporeservations',
          name: 'cporeservations',
          component: CPOReservations
        },
        // {
        //   path: 'globalOTPVerification',
        //   name:'globalOTPVerification',
        //   component: GlobalOTPVerification
        // },
        {
          path: 'cpoAdminDashboard',
          name: 'cpoAdminDashboard',
          component: CPOAdminDashboard
        },
        {
          path: 'cpoReport',
          name: 'cpoReport',
          component: CPOReport
        },
        {
          path: 'usageReport',
          name: 'usageReport',
          component: UsageReport
        },
        {
          path: 'transactionReport',
          name: 'transactionReport',
          component: TransactionReport
        },
        {
          path: 'chargerstatusreport',
          name: 'chargerstatusreport',
          component: chargerStatusReport
        }
      ]
    },
    {
      path: '/corporate',
      component: Index,
      children: [
        
        {
          path: 'branchCPO',
          name: 'branchCPO',
          component: BranchCPO 
        },
        {
          path: 'branchDetails',
          name: 'branchDetails',
          component: BranchDetails 
        },
        {
          path: 'branchView',
          name: 'branchView',
          component: BranchView
        },
        {
          path: 'manageUserToBranch',
          name: 'manageUserToBranch',
          component: ManageUserToBranch
        },
        {
          path: "associateUserToBranch",
          name: "associateUserToBranch",
          component: AssociateUserToBranch
        },
        {
          path: 'userBranchRelationshipDetails',
          name: 'userBranchRelationshipDetails',
          component: UserBranchRelationshipDetails
        }
      ]
    },
    {
      path: '/notifications',
      component: Index,
      children: [
        {
          path: 'notifications',
          name: 'notifications',
          component: Notifications 
        },
        {
          path: 'notificationDetails',
          name: 'notificationDetails',
          component: NotificationDetails 
        }
       ]
    },
    {
      path: '/carter',
      component: Index,
      children: [
        {
          path: 'carterHome',
          name: 'carterReservation',
          component: CarterReservation 
        },
        {
          path: 'carterBookNow',
          name: 'carterBookNow',
          component: CarterBookNow 
        },
        {
          path: 'carterProfile',
          name: 'carterProfile',
          component: CarterProfile 
        },
        {
          path: 'carterStations',
          name: 'carterStations',
          component: CarterStations 
        },
        {
          path: 'carterStationDetatils',
          name: 'carterStationDetatils',
          component: CarterStationDetails 
        },
        {
          path: 'carterDashboard',
          name: 'carterDashboard',
          component: CarterDashboard 
        },
        {
          path: 'carterUserManagement',
          name: 'carterUserManagement',
          component: CarterUserManagement 
        },
        {
          path: 'carterProfileEdit',
          name: 'carterProfileEdit',
          component: CarterProfileEdit 
        }
       ]
    },
    {
      path: '/logout',
      name: 'logout',
      redirect: '/login'
    }
  ]

  const router = createRouter({
    // comment for migration uses
    // history: createWebHashHistory(process.env.BASE_URL),
    history: createWebHistory(),
    routes
  })
//Below code is added by vinoth 26.02.2021 because swide fixed navigation issue with this code

//The following code block will stop the Back button activity (in Android and Browser)
router.beforeEach((to, from, next) => {
  
  //From the Confirmation Splash screen to All screens except NewReservation
  if(from.name == "resConfirm" && to.name != "newreservation") return next(false);

  //From Home View to Confirmation Splash screen
  if(from.name != "confirmPage" && to.name == "resConfirm") return next(false);

  //From Home View to Signup OTP
  if(from.name != "signup" && to.name == "signupOtp") return next(false);

  //From Home View to Reset Password
  if(from.name != "passwordOtp" && to.name == "resetPassword") return next(false);

  //From Reset Password to Password OTP Verification
  if(from.name == "resetPassword" && to.name == "passwordOtp") return next(false);

  //From NewReservation to any of the Security View
  if(from.name == "newreservation" && (to.name == "passwordOtp" || to.name == "resetPassword" || to.name == "signupOtp") ) return next(false);

  //From myReservation to confirmPage
  if(from.name == "myReservationView" && to.name == "confirmPage") return next("/customer/reservations");

   //From myReservation to confirmPage
   if(from.name == "myReservations" && to.name == "confirmPage") return next(false);

  return next();
});
export default router
